import React from "react";

import "./ContextualLayers.scss";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  withStyles,
} from "@material-ui/core";

const PrimaryRadio = withStyles({
  root: {
    color: "rgba(1,11,27,.8)",
    "&$checked": {
      color: "rgba(1,11,27,1)",
    },
  },
  checked: {},
})((props) => (
  <Radio
    style={{ fontFamily: "Lato", fontSize: 14, paddingBottom: 6, paddingTop: 6 }}
    color="default"
    {...props}
  />
));

function ContextualLayers(props) {
  const { layersToInclude, selectedStat, handleLayerToggle } = props; //layersEnabled,

  return (
    <div className="contextualLayers" name="contextualLayers">
      <RadioGroup
        aria-label="Contextual Layers"
        name="contextualLayers"
        value={selectedStat}
        onChange={handleLayerToggle}
      >
        {layersToInclude.map((layer) => (
          <FormControlLabel
            key={layer.id}
            className="contextualLayerItem"
            value={layer.id}
            control={<PrimaryRadio />}
            label={layer.overrideTitle || layer.title}
          />
          // <ContextualLayerItem

          //   defaultChecked={
          //     layer.id === selectedStat || (!selectedStat && n === 0)
          //   }
          //   handleLayerToggle={handleLayerToggle}
          //   layer={layer}
          //   isVisible={layersEnabled.includes(layer.id)}
          // />
        ))}
      </RadioGroup>
    </div>
  );
}

export default ContextualLayers;
